"use client"
import { Divider, Stack, Typography } from "@mui/material"
import Grid from "@mui/material/Grid"
import { PageFooterLogo } from "@tc/ui-dfe/utils/svg"
import { Link } from "../Link"
import { TERMS_AND_CONDITIONS_LINK } from "@tc/ui-dfe/utils/constants"
import { BuildVersionInfo } from "../Layout/BuildVersionInfo"
export const PageFooter = () => {
  return (
    <Grid
      component={"footer"}
      sx={{
        height: {
          xs: "auto",
          md: "70px",
        },
        bgcolor: "footer.main",
        px: {
          xs: 3,
          sm: 4,
        },
        py: 2,
        alignContent: "space-around",
      }}
      spacing={0}
      container
    >
      <Grid
        size={{ xs: 12, md: 6 }}
        sx={{ display: "flex", alignItems: "center", gap: 2 }}
      >
        <Link href="https://www.govt.nz/" external custom>
          <PageFooterLogo style={{ width: 165, height: 17 }} />
        </Link>
        <BuildVersionInfo />
      </Grid>
      <Grid
        size={{ xs: 12 }}
        sx={{
          display: {
            xs: "block",
            md: "none",
          },
          height: "1px",
          mt: 1.2,
          mb: 1,
        }}
      >
        <Divider
          orientation="horizontal"
          flexItem
          sx={{
            borderColor: (theme) => theme.palette.primary.main,
          }}
        />
      </Grid>
      <Grid
        size={{ xs: 12, md: 6 }}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: {
            xs: "unset",
            md: "end",
          },
        }}
        data-testid="footer-links"
      >
        <Stack direction="row" spacing={{ xs: 2, sm: 3 }}>
          <Link
            href={TERMS_AND_CONDITIONS_LINK}
            external
            tabIndex={0}
            disableGutters
          >
            <Typography variant="h6">Terms and Conditions</Typography>
          </Link>
          <Link
            href="https://www.mpi.govt.nz/contact-us/"
            tabIndex={0}
            external
            disableGutters
          >
            <Typography variant="h6">Contact Information</Typography>
          </Link>
          <Link
            href="https://www.mpi.govt.nz/about-this-site/mpi-copyright/"
            tabIndex={0}
            external
            disableGutters
          >
            <Typography variant="h6">Copyright</Typography>
          </Link>
          <Link
            href="https://www.mpi.govt.nz/about-this-site/privacy-and-security/"
            tabIndex={0}
            external
            disableGutters
          >
            <Typography variant="h6">Privacy</Typography>
          </Link>
        </Stack>
      </Grid>
    </Grid>
  )
}
